import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-save-popup',
    templateUrl: './save-popup.component.html',
    styleUrls: ['./save-popup.component.scss'],
    standalone: false
})
export class SavePopupComponent {
    public subject: Subject<boolean>;
    public popupTitle;
    public popupText;
    public errorDetail;

    constructor(public bsModalRef: BsModalRef) {}

    action(value: boolean) {
        this.bsModalRef.hide();
        this.subject.next(value);
        this.subject.complete();
    }
}
